import React from 'react';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from './Dialog/Dialog';
import TextSearchInput from '../fields/TextInput/TextSearchInput';
import { Button, Icons } from './BootstrapComponents/BootstrapComponents';
import FieldDTO from '../fields/Abstract/FieldDTO';
import { createClearObject } from '../../utils/utils';

export default function MobileSearchModal(props) {
  const {
    control,
    defaultValues,
    reset = () => {},
    handleClose = () => {},
    getValues = () => {},
    inputProps = null,
  } = props;

  const clear = () => {
    const fields = getValues();
    const cleared = createClearObject(fields);
    reset({ ...cleared, ...defaultValues });
  };

  const addProps = inputProps ? { inputProps } : {};

  return (
    <Dialog
      className="mobile-search-modal"
      onClose={() => { handleClose(); }}
      size="xl"
      open
    >
      <DialogContent className="msm-content">
        <div className="msm-header">
          <div className="title-text">Поиск</div>
          <div className="close-wrapper">
            <Icons width={14} height={14} customIcon icon="clear" className="hff-close" onClick={handleClose} />
          </div>
        </div>
        <FieldDTO
          control={control}
          component={TextSearchInput}
          dtoObject={{
            name: 'search',
            type: String,
            labelKey: 'search',
          }}
          className="no-border"
          {...addProps}
        />
      </DialogContent>
      <DialogFooter className="msm-footer">
        <Button variant="secondary" onClick={clear}>Сбросить</Button>
        <Button onClick={handleClose}>Найти</Button>
      </DialogFooter>
    </Dialog>
  );
}
